import { isEmpty, trim } from 'lodash/fp';
import pt from 'prop-types';
import { Component } from 'react';
import { LocalizationSubscribeContext } from '@mews/framework';
import { SimpleMarkdown } from './SimpleMarkdown';

export class LocalizedMarkdown extends Component {
    declare context: LocalizationSubscribeContext & {
        localizeProperty: Function;
    };
    static contextTypes = {
        localizationSubscribe: pt.func.isRequired,
        localizeProperty: pt.func.isRequired,
    };

    componentDidMount() {
        (this as $TSFixMe).unsubscribe = this.context.localizationSubscribe(() => this.forceUpdate());
    }

    componentWillUnmount() {
        (this as $TSFixMe).unsubscribe();
    }

    render() {
        // @ts-expect-error $TSFixMeError: Property 'property' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
        const { property, ...others } = this.props;
        const localizedText = trim(this.context.localizeProperty(property));

        return !isEmpty(localizedText) ? <SimpleMarkdown {...others} text={localizedText} /> : null;
    }
}
